import React from 'react'
import { Icon } from 'semantic-ui-react'
import { Card, Stack, Typography, Button } from '@prometheus/components'
import translateOrbitingPlanet from '../../../../utils/translateOrbitingPlanet'
import './MobileTurnStatus.scss'

// Phone-only "Now" card pinned to the top of the Turn tab. The desktop middle
// column is legitimately empty in several phases (the board carries the
// context there), but on a phone the board lives behind another tab — this
// card keeps the Turn tab anchored: where you are, whether the game is
// waiting on you, and a one-tap bridge to the board.
export interface MobileTurnStatusProps {
  // e.g. "U:Portia" — orbit prefix + planet name.
  planetKey?: string
  // Dice, as stored on the player (summed for display like PlayerStatusList).
  roll?: number[]
  // The game is waiting on THIS player to pick a movement target.
  isMyMove: boolean
  tradeOpen: boolean
  onViewBoard: () => void
}

export const MobileTurnStatus = ({ planetKey, roll, isMyMove, tradeOpen, onViewBoard }: MobileTurnStatusProps) => {
  if (!planetKey) {
    return null
  }

  const [orbit, ...rest] = planetKey.split(':')
  const name = rest.join(':') || orbit
  const orbitName = translateOrbitingPlanet(orbit)
  const rollTotal = (roll || []).reduce((a, b) => a + b, 0)

  return (
    <Card
      className="pg-turn-status"
      padding="sm"
      borderColor={isMyMove ? 'warning' : 'tertiary'}
      style={{ position: 'relative', zIndex: 1 }}
    >
      <Stack space="sm">
        <Stack direction="row" style={{ justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 'var(--prometheus-spacing-sm)' }}>
          <Typography className="pg-turn-status__location">
            <Icon name="rocket" />
            Docked at <Typography component="span" color="primary" bold>{name}</Typography>
            {orbitName !== name && (
              <Typography component="span" color="secondary"> — {orbitName}</Typography>
            )}
          </Typography>
          {rollTotal > 0 && (
            <Typography className="pg-turn-status__roll" retro>Roll: {rollTotal}</Typography>
          )}
        </Stack>
        {isMyMove && (
          <Typography color="warning" bold>
            Your move — pick a glowing planet on the board.
          </Typography>
        )}
        {tradeOpen && !isMyMove && (
          <Typography color="secondary">
            The Galactic Trader is open below.
          </Typography>
        )}
        <Button size="sm" outline variant={isMyMove ? 'warning' : 'secondary'} onClick={onViewBoard}>
          <Icon name="globe" /> View Board
        </Button>
      </Stack>
    </Card>
  )
}

export default MobileTurnStatus
